/**
 * DrivOn brand palette (Brand Guidelines 2024). The CSS tokens in assets/css/brand.css hold the same
 * values; tools/brand-audit/tokens.test.mjs keeps the two in sync. For canvas and WebGL colours.
 */
export const BRAND = {
  purple: '#6950a1',
  purple80: '#8773b4',
  purple50: '#b4a8d0',
  white: '#eeedf6',
  white50: '#f1f0f8',
  pureWhite: '#ffffff',
  black: '#000000',
  black80: '#282828',
  black60: '#636363',
  green: '#07423a',
  green80: '#376861',
  green50: '#82a09c',
} as const;
